export const userState = {
  pan_iib_verification: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/sp-registration/pan-verification',
    message: null,
    next: 'personal_details',
    prev: 'NONE',
    key: 'PAN IIB Verification',
    subhead: 'Proceed with PAN IIB Verification',
    data: {},
    state_name: 'TRAINING',
  },
  personal_details: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/sp-registration/personal-details',
    message: null,
    next: 'doc_upload',
    prev: 'pan_iib_verification',
    key: 'Personal Details',
    subhead: 'Proceed with Personal Details',
    data: {},
    state_name: 'LIFE',
  },
  doc_upload: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/sp-registration/document-upload',
    message: null,
    next: 'training_module',
    prev: 'personal_details',
    key: 'Document Upload',
    subhead: 'Proceed with document upload to have your details fetched',
    data: {},
    state_name: 'PAN_CHECK',
  },
  training_module: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/sp-registration/training',
    message: null,
    next: 'life_insu_exam',
    prev: 'doc_upload',
    key: 'Training Module',
    subhead: 'Proceed with Training Module',
    data: {},
    state_name: 'LIFE',
  },
  life_insu_exam: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/sp-registration/examination-instruction',
    message: null,
    next: 'final_iib_verification',
    prev: 'training_module',
    key: 'Life Insurance exam',
    subhead: 'Proceed with Life Insurance exam',
    data: {},
    state_name: 'DOCUMENTS_UPLOAD',
  },
  final_iib_verification: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/registration-status',
    message: null,
    next: 'agreement_generated',
    prev: 'life_insu_exam',
    key: 'Final IIB Verification',
    subhead: 'You will soon receive confirmation from Zopper Insurance Brokers Private Limited.',
    data: {},
    state_name: 'PERSONAL_DETAILS',
  },
  agreement_generated: {
    status: 'INCOMPLETE',
    proceedRoute: '/posp/registration-status',
    message: null,
    next: 'NONE',
    prev: 'final_iib_verification',
    key: 'Aggrement Generated',
    subhead:
      'You will soon receive aggrement generated from Zopper Insurance Brokers Private Limited.',
    data: {},
    state_name: 'PERSONAL_DETAILS',
  },
}
